import axiosInstance from "./axios";

export class HorarioAsistenciaService {
    getHorarios() {
        return axiosInstance
            .get(`/horarioasistencia`)
            .then((res) => res.data)
    }

    addHorario(dto) {
        return axiosInstance
            .post(`/horarioasistencia`, dto)
            .then((res) => res.data)
    }

    updateHorario(dto) {
        return axiosInstance
            .put(`/horarioasistencia/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteHorario(id) {
        return axiosInstance
            .delete(`/horarioasistencia/${id}`)
            .then((res) => res.data)
    }
}
